import { Link } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";

// A quiet way into the Growth Desk while the site is still in preview.
// It never renders on the live domain, so the public site stays clean.
const isPreview = typeof window !== "undefined" &&
  (window.location.hostname.includes("preview") ||
   window.location.hostname.includes("localhost") ||
   window.location.hostname.endsWith(".emergent.host"));

export const DeskLink = () => {
  if (!isPreview) return null;
  return (
    <Link
      to="/admin"
      data-testid="desk-shortcut"
      title="Growth Desk (preview only)"
      className="fixed bottom-5 left-5 z-50 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-forest/90 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold backdrop-blur-md transition-colors duration-200 hover:bg-forest hover:text-cream"
    >
      <LayoutDashboard className="h-3.5 w-3.5" />
      Growth Desk
    </Link>
  );
};
